// import { Cascader, Select } from 'antd';
import './style.scss';
// import { CaretDownOutlined } from '@ant-design/icons';
// import { DefaultOptionType } from 'antd/es/cascader';
import React, { useEffect, useState } from 'react';
import {
  IGameEnvModel,
  IApiGameEnvCollectionRes,
} from '../../../model/api-modules/env';
import { IAPIGameItem } from '../../../model/api-modules';
import { RbacRoleObjectKey } from '../../../model/rbac';
import { IGameURLParams } from '../../../model';
import { formatEnvCollectionOptions } from './env';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { IRootState } from '../../../store/reducers';
import {
  getGameList,
  GamesAction,
  ReduxGamesActionType,
  getEnvCollectionList,
} from '../../../store/modules/games';
import { getCurrentDefaultEnvID, getPathnameBySwitchGameEnv } from '../lib';
import { fetchEnvList } from '../../../api/game/env';
import { setLocalGameFilter } from './lib';
import { CreateGameModal } from '../../component/create-game-modal';
import { CreateEnvModal } from '../game-info/components/create-env-modal';
import SwitchIcon from '../../../assets/svg/switch-icon.svg';
import SwitchIconHover from '../../../assets/svg/switch-icon-hover.svg';
import EnvDevIcon from '../../../assets/img/env-dev-icon.png';
import EnvLiveIcon from '../../../assets/img/env-live-icon.png';
import SelectGameRight from '../../../assets/svg/select-game-right.svg';
import StudioSelectIcon from '../../../assets/svg/studio-select-icon.svg';
import { GameAvatar } from '../common/game-avatar';
import classNames from 'classnames';
import getFormatMessage from '../../../locales/get-format-message';
import { Link } from 'react-router-dom';
import BackToStudio from '../../../assets/svg/back-to-studio.svg';
import OrganizationIcon from '../../../assets/svg/organization-icon.svg';
import SettingIcon from '../../../assets/svg/setting.svg';
import BillingIcon from '../../../assets/svg/billing.svg';
import AuditHubIcon from '../../../assets/svg/text-chat-dark.svg';
import HomeWebsite from '../../../assets/svg/home-website.svg';
import { onToHomePage } from '../../lib';
import GameBackIcon from '../../../assets/svg/game-back-icon.svg';
import GameBackIconHover from '../../../assets/svg/game-back-icon-hover.svg';
import MenuDown from '../../../assets/svg/menu-down.svg';
import { PermissionCheck } from '../../component/permission-check';

interface IProps {
  readonly gameList: ReadonlyArray<IAPIGameItem>;
  readonly pathnameParams: IGameURLParams;
  readonly envs: ReadonlyArray<IGameEnvModel>;
  readonly onToRouter: (pathname: string) => void;
  readonly studioId: string | undefined;
}

export const GameFilter = (props: IProps) => {
  const gamesDispatch = useDispatch<Dispatch<GamesAction>>();
  const storedAllEnvList = useSelector(
    (state: IRootState) => state.games.allEnvList
  );

  // const [envOptions, setEnvOptions] = useState<Array<DefaultOptionType>>([]);
  const [showCreateGameModal, setShowCreateGameModal] =
    useState<boolean>(false);
  const [showCreateEnvModal, setShowCreateEnvModal] = useState<boolean>(false);
  const [allEnvList, setAllEnvList] = useState<any>({});
  const [selectedCerateEnvGame, setSelectedCerateEnvGame] =
    useState<IAPIGameItem>();
  // const envList = useSelector((state: IRootState) => state.games.allEnvList);
  const studioInfo = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );

  const regionItem = props.gameList.find(
    (item) => item.gameID === props.pathnameParams.gameId
  );
  const envItem = props.envs.find(
    (item) => item.id === Number(props.pathnameParams.envId)
  );
  const selectedGame = props.gameList.find(
    (item) => regionItem?.gameID === item.gameID
  );

  useEffect(() => {
    getEnvCollection();
  }, [props.gameList]);

  useEffect(() => {
    initAllEnvs(storedAllEnvList);
  }, [storedAllEnvList]);

  const getEnvCollection = async () => {
    // const res = await fetchEnvCollectionList();
    let res: IApiGameEnvCollectionRes[] | null;
    if (props.studioId) {
      res = await getEnvCollectionList(gamesDispatch)(props.studioId);
    } else {
      res = [];
    }

    if (res) {
      initAllEnvs(res);
    }
  };

  const initAllEnvs = (rawEnvs: IApiGameEnvCollectionRes[]) => {
    const envDataList = props.gameList.map((item) => {
      const envs: any = [];
      rawEnvs.forEach((env) => {
        if (item.gameID === env.gameID) {
          envs.push(env);
        }
      });
      return { name: item.gameID, envs };
    });
    const envCollectionList = envDataList.reduce((acc: any, { name, envs }) => {
      acc[name] = envs;
      return acc;
    }, {});
    setAllEnvList(envCollectionList);
  };

  // useEffect(() => {
  //   const options = formatEnvOptions(props.envs);
  //   setEnvOptions(options);
  // }, [props.envs]);

  const onGameChange = async (id: string) => {
    const envs = (await fetchEnvList(id)) || [];
    const envID = getCurrentDefaultEnvID(id, envs);
    props.onToRouter(getPathnameBySwitchGameEnv(envID, id));
  };

  const onEnvChange = (gamaId: string, envId: number) => {
    setLocalGameFilter(gamaId, envId);
    props.onToRouter(getPathnameBySwitchGameEnv(envId));
  };

  // const getCascaderValue = (envId: number) => {
  //   if (envOptions) {
  //     for (const opt of envOptions) {
  //       const target = (opt.children || []).find((v) => v.value === envId);
  //       if (target) {
  //         return [opt.value, target.value];
  //       }
  //     }
  //   }
  //   return [];
  // };
  const queryGameList = async () => {
    // @ts-ignore
    await getGameList(gamesDispatch)();
  };

  const renderAddGameCard = () => {
    if (showCreateGameModal) {
      return (
        <CreateGameModal
          onReload={queryGameList}
          onClosed={() => setShowCreateGameModal(false)}
        />
      );
    }
    return null;
  };

  const showGameMenu = () => {
    const menu = document.querySelector('.game-select-box') as HTMLElement;
    if (menu) {
      menu.style.display = 'block';
    }
  };

  const hideGameMenu = () => {
    const menu = document.querySelector('.game-select-box') as HTMLElement;
    if (menu) {
      menu.style.display = 'none';
    }
  };

  const showEnvMenu = (gameId: string) => {
    const menu = document.getElementById(`env-select-${gameId}`) as HTMLElement;
    if (menu) {
      menu.style.display = 'block';
    }
  };

  const hideEnvMenu = (gameId: string) => {
    const menu = document.getElementById(`env-select-${gameId}`) as HTMLElement;
    if (menu) {
      menu.style.display = 'none';
    }
  };

  const renderEnvShow = () => {
    // let label: any = '';
    // envOptions.map((item) => {
    //   item.children?.map((it) => {
    //     if (it.id === Number(props.pathnameParams.envId)) {
    //       label = item.label;
    //     }
    //     return label;
    //   });
    //   return label;
    // });
    const name = envItem?.Name ? envItem?.Name : '';
    return (
      <div className="game-filter-box">
        <div className="avatar-filter-box">
          <div className="avatar-filter-div">
            <div className="avatar-icon-box">
              <img src={GameBackIcon} className="game-back-icon" />
              <img src={MenuDown} className="menu-down-icon" />
            </div>
            <div className="avatar-hover-icon-box">
              <img src={GameBackIconHover} className="game-back-icon" />
              <img src={MenuDown} className="menu-down-icon" />
            </div>
          </div>
          {renderAvatarHover()}
        </div>
        <div className="game-filter-show-box">
          <div
            className="game-filter-show-region"
            title={regionItem?.gameName || ''}
          >
            {regionItem?.gameName || ''}
          </div>
          <div className="game-filter-show-env">
            <div className="game-filter-show-env-name" title={name}>
              {envItem?.Name}
            </div>
            {envItem?.Type === 'DEV' && (
              <img src={EnvDevIcon} className="game-filter-show-env-type" />
            )}
            {envItem?.Type === 'LIVE' && (
              <img src={EnvLiveIcon} className="game-filter-show-env-type" />
            )}
          </div>
        </div>
        <div
          className="game-filter-env-img-box"
          onMouseOver={showGameMenu}
          onMouseOut={hideGameMenu}
        >
          <img src={SwitchIcon} className="game-filter-show-env-img" />
          <img
            src={SwitchIconHover}
            className="game-filter-show-env-img-hover"
          />
          {renderGameSelect()}
        </div>
      </div>
    );
  };

  const renderAvatarHover = () => {
    return (
      <div className="avatar-filter-hover-box">
        <div className="avatar-filter-hover-name">
          {studioInfo?.studioName || ''}
        </div>
        <div className="avatar-filter-hover-back-link">
          <Link
            to={`/studio/${studioInfo?.studioID}/portal`}
            className="sidebar-back"
          >
            <div className="col-icon">
              <img src={BackToStudio} className="back-to-studio-icon" />
            </div>
            <div className="col-text">{getFormatMessage('back_to_studio')}</div>
          </Link>
        </div>
        <div className="avatar-filter-hover-back-link">
          <Link
            to={`/studio/${studioInfo?.studioID}/organization`}
            className="sidebar-back"
          >
            <div className="col-icon">
              <img src={OrganizationIcon} className="back-to-studio-icon" />
            </div>
            <div className="col-text">{getFormatMessage('organization')}</div>
          </Link>
        </div>
        <div className="avatar-filter-hover-back-link">
          <Link
            to={`/studio/${studioInfo?.studioID}/setting`}
            className="sidebar-back"
          >
            <div className="col-icon">
              <img src={SettingIcon} className="back-to-studio-icon" />
            </div>
            <div className="col-text">{getFormatMessage('setting_name')}</div>
          </Link>
        </div>

        <div className="avatar-filter-hover-back-link">
          <Link
            to={`/studio/${studioInfo?.studioID}/fee/overview`}
            className="sidebar-back"
          >
            <div className="col-icon">
              <img src={BillingIcon} className="back-to-studio-icon" />
            </div>
            <div className="col-text">{getFormatMessage('billing')}</div>
          </Link>
        </div>

        <div className="avatar-filter-hover-back-link">
          <Link
            to={`/studio/${studioInfo?.studioID}/audithub`}
            className="sidebar-back"
          >
            <div className="col-icon">
              <img src={AuditHubIcon} className="back-to-studio-icon" />
            </div>
            <div className="col-text">{getFormatMessage('per_audit')}</div>
          </Link>
        </div>
        <div className="avatar-filter-hover-back-line"></div>
        <div className="avatar-filter-hover-back-link">
          <div className="sidebar-back" onClick={onToHomePage}>
            <div className="col-icon">
              <img src={HomeWebsite} className="back-to-studio-icon" />
            </div>
            <div className="col-text">{getFormatMessage('go_to_website')}</div>
          </div>
        </div>
      </div>
    );
  };

  const renderEnvSelect = (game: IAPIGameItem) => {
    const envs = allEnvList[game.gameID] || [];
    const options = formatEnvCollectionOptions(envs);

    const optionEnvs = [...options]
      .map(
        (region) =>
          region.children?.map((child) => {
            return {
              ...child,
              regionName: region.label,
            };
          }) || []
      )
      .flat()
      .sort((a, b) => (a.envIncrementID > b.envIncrementID ? 1 : -1));

    return (
      <div className="env-select-padding-box" id={`env-select-${game.gameID}`}>
        <div className="env-select-box">
          <div className="env-select-opts">
            {optionEnvs?.length !== 0 &&
              optionEnvs.map((it) => {
                return (
                  <div
                    className="env-select-box-item"
                    key={it.value}
                    onClick={() => onEnvChange(game.gameID, it.envIncrementID)}
                  >
                    <div className="env-select-item-content">
                      <span
                        className="env-filter-show-env-text"
                        title={`${it.envName} - ${it.regionName}`}
                      >
                        {it.envName} - {it.regionName}
                      </span>
                      {it.envType === 'DEV' && (
                        <img
                          src={EnvDevIcon}
                          className="env-filter-show-env-type"
                        />
                      )}
                      {it.envType === 'LIVE' && (
                        <img
                          src={EnvLiveIcon}
                          className="env-filter-show-env-type"
                        />
                      )}
                    </div>
                    {envItem?.id === it.envIncrementID && (
                      <img src={StudioSelectIcon} className="env-select-icon" />
                    )}
                  </div>
                );
              })}
          </div>
          <div className="game-select-btn">
            <PermissionCheck
              permissionKey={RbacRoleObjectKey.EnvCreate}
              gameID={game.gameID}
              forceShow={true}
            >
              <span
                className="game-select-btn-text"
                onClick={() => {
                  setSelectedCerateEnvGame(game);
                  setShowCreateEnvModal(true);
                }}
              >
                {getFormatMessage('create_new_env')}
              </span>
            </PermissionCheck>
          </div>
        </div>
      </div>
    );
  };

  const clickCreate = () => {
    setShowCreateGameModal(true);
  };

  const renderGameSelect = () => {
    return (
      <div className="game-select-box">
        {props.gameList.map((item, index) => {
          return (
            <div
              className="game-select-box-item"
              key={index}
              onClick={() => onGameChange(item.gameID)}
              onMouseOver={() => showEnvMenu(item.gameID)}
              onMouseOut={() => hideEnvMenu(item.gameID)}
            >
              <GameAvatar
                width="40px"
                name={item.gameName}
                color={item.gameColor}
                fontSize="22px"
              />
              <div className="game-select-item-content">
                <div
                  className="game-select-item-title"
                  title={item?.gameName || ''}
                >
                  {item?.gameName || ''}
                </div>
                {regionItem?.gameID === item.gameID && (
                  <div className="game-select-item-env">
                    <span
                      className="game-filter-show-env-text"
                      title={envItem?.Name}
                    >
                      {envItem?.Name}
                    </span>
                    {envItem?.Type === 'DEV' && (
                      <img
                        src={EnvDevIcon}
                        className="game-filter-show-env-type"
                      />
                    )}
                    {envItem?.Type === 'LIVE' && (
                      <img
                        src={EnvLiveIcon}
                        className="game-filter-show-env-type"
                      />
                    )}
                  </div>
                )}
              </div>
              <img src={SelectGameRight} className="game-select-right-icon" />
              {renderEnvSelect(item)}
            </div>
          );
        })}
        <div className="game-select-btn">
          <PermissionCheck permissionKey={RbacRoleObjectKey.GameCreate}>
            <span
              className={classNames('game-select-btn-text')}
              onClick={clickCreate}
            >
              {getFormatMessage('create_new_title')}
            </span>
          </PermissionCheck>
        </div>
      </div>
    );
  };

  const getEnvList = async () => {
    if (selectedGame?.gameID) {
      const res = await fetchEnvList(selectedGame.gameID);
      if (res) {
        gamesDispatch({
          type: ReduxGamesActionType.SET_ALL_ENVS,
          result: res,
        });
      }
    }
  };

  const renderCreateEnv = () => {
    return (
      <CreateEnvModal
        isShow={showCreateEnvModal}
        // serviceData={serviceData}
        onClose={() => setShowCreateEnvModal(false)}
        refresh={() => getEnvList()}
        selectedGame={selectedCerateEnvGame}
      />
    );
    // if (showCreateEnvModal) {
    //   return (
    //     <CreateEnvModal
    //       // serviceData={serviceData}
    //       onClose={() => setShowCreateEnvModal(false)}
    //       refresh={() => getEnvList()}
    //       selectedGame={selectedGame}
    //     />
    //   );
    // }
    // return null;
  };

  return (
    <div className="game-filter">
      {renderEnvShow()}
      {renderAddGameCard()}
      {renderCreateEnv()}
    </div>
  );
};
